import React from 'react'

import {Alert as ReactStrapAlert} from 'reactstrap'

import {ALERT_TYPES, hideAlert} from '../../../infra/utils/alerts'
import Icon from '../icon'
import {alertTypeConfig} from './alertTypeConfig'
import {AlertMessage} from './components/AlertMessage'

export const Alert = ({
  message,
  heading,
  footer,
  id,
  type = ALERT_TYPES.ERROR
}) => {
  const alertConfig = alertTypeConfig[type]

  const handleCloseAlert = () => {
    hideAlert(id)
  }

  if (alertConfig.small) {
    return (
      <ReactStrapAlert
        color={alertConfig.color}
        className="border-0 border-0 alert-animation small-alert"
        toggle={handleCloseAlert}>
        <span className="headless-title">{message}</span>
      </ReactStrapAlert>
    )
  }

  return (
    <>
      <ReactStrapAlert
        color={alertConfig.color}
        className="alert-additional alert-animation"
        toggle={handleCloseAlert}>
        <div className="alert-body">
          <div className="d-flex">
            <div className="flex-shrink-0 me-3">
              <Icon
                className="fs-16 align-middle alert-margin-top"
                icon={alertConfig.icon}
                size={[16, 16]}
              />
            </div>
            <div className="flex-grow-1">
              <h5 className="alert-heading">{heading}</h5>
              <div className="mb-0 alert-subtitle ">
                <AlertMessage messages={message} />
              </div>
            </div>
          </div>
        </div>
        {footer && (
          <div className="alert-content">
            <p className="mb-0 text-white headless-title">{footer}</p>
          </div>
        )}
      </ReactStrapAlert>
    </>
  )
}
